module.exports = __webpack_public_path__ + "static/img/Paul-Gallen.93c5328.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Paul-Gallen.jpg
// module id = cc2C
// module chunks = 0